/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import {
    Button, Typography, TextField, Box
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { toast } from 'react-toastify';
import clsx from "clsx";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { ListTable } from './ListTable';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const FeatureList = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleDetails, featureDetails, loader } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorLabels, setErrorLabels] = useState(false);

    const [errorModuleId, setErrorModuleId] = useState(false);
    const { history } = props;

    const [addMore, setAddMore] = useState(false);
    const [featureId, setFeatureId] = useState(false);
    const [name, setName] = useState('');
    const [view, setView] = useState(false);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);

    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const dispatch = useDispatch();

    const [form, setForm] = useState({
        moduleId: "",
        featureName: "",
        description: ""
    });

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");



    const classes = customStyles();

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };
    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    };

    const loadTasks = useCallback(() => {
        if (moduleDetails.length === 0) {
            dispatch({
                type: actions.MODULE_DETAILS_START, filter: {
                    order: 'id  desc'
                }
            });
        }
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Feature List', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ featureName: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'features',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const createModule = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.featureName);
        let emptyLabels = emptyValidation('UI Label', form.uiLabel);
        let emptyModule = emptyValidation('Module', form.moduleId, 'dropDown');
        emptyState();
        if (emptyName.isValid && emptyModule.isValid && emptyLabels.isValid) {
            delete form.percentage;
            delete form.moduleName;
            dispatch({
                type: featureId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'features',
                title: 'Features',
                id: featureId,
                details: form
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyModule.errors) {
                setErrorModuleId(emptyModule.errors);
            }
            if (emptyLabels.errors) {
                setErrorLabels(emptyLabels.errors);
            }
        }
    }

    const emptyStateInput = () => {
        setForm({
            moduleId: "",
            featureName: "",
            uiLabel: "",
            description: ""
        });
        setFeatureId('');
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorLabels(false);
        setErrorModuleId(false);
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorName(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorName(error);
        }
    }, [editDetails, editError]);

    const onEdit = (data) => {
        setView(false);
        setVisible(true);
        setFeatureId(data.id);
        setForm({
            featureName: data.featureName,
            uiLabel: data.uiLabel,
            description: data.description,
            moduleId: data.moduleId
        });
    }

    const onView = (data) => {
        setView(true);
        setVisible(true);
        setFeatureId(data.id);
        setForm({
            featureName: data.featureName,
            description: data.description,
            uiLabel: data.uiLabel,
            moduleId: data.moduleId,
            moduleName: data?.module?.module
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setFeatureId(data.id);
        setName(data.featureName);
    };

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleAddMore = (e) => {
        createModule(e);
        setAddMore(true);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.FEATURE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'features',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Feature List', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Feature List'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Feature List', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Feature List', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Features'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Feature List', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Feature List', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Feature</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Feature List', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                onView={(data) => onView(data)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                                from={"Feature List"}
                            />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${featureId ? 'Edit' : 'Add'} Feature`}
                    width={'360px'}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createModule(e)}>
                            <div className={classes.customFormFlex}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.moduleName}</Typography>
                                    </> :
                                        <AutoCompleteComponent
                                            name={["Module ", <span key={"Module"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'module', 'name': 'Module' }]}
                                            details={moduleDetails}
                                            parentValue={customObject(moduleDetails, form.moduleId)}
                                            onChange={(data) => changeHandler(data.id, 'moduleId')}
                                            parentError={errorModuleId}
                                            position={"bottom"}
                                        />
                                }
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.featureName}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            className={clsx(classes.margin30t)}
                                            error={errorName ? true : false}
                                            helperText={errorName}
                                            name={"featureName"}
                                            value={form.featureName}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>UI Label</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.uiLabel}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            label={["UI Labels ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            className={clsx(classes.margin30t)}
                                            error={errorLabels ? true : false}
                                            helperText={errorLabels}
                                            name={"uiLabel"}
                                            value={form.uiLabel}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            label='Description'
                                            name={"description"}
                                            value={form.description}
                                            multiline
                                            variant="outlined"
                                            className={clsx(classes.margin30t, classes.customDescription)}
                                            rows={20}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColor,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                {
                                    !view &&
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                        >
                                            {
                                                featureId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !featureId && <Button
                                                key="add"
                                                onClick={(e) => handleAddMore(e)}
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >
                                                Add more
                                            </Button>
                                        }

                                    </Space>
                                }
                            </div>
                        </Box>
                    }
                />
                <DeleteModal
                    onClose={(v) => handleDeleteModal(v)}
                    id={featureId}
                    loadTasks={() => loadTasks()}
                    name={name}
                    url={'features'} title={'Feature'} visible={deleteModal} />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Features'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={featureDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}

export default FeatureList